var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    preserveAspectRatio: "none",
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_356_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6278 1.89678L6.69144 0H0L0 13.53L0.52 14.113H29.4116L30 13.5246V2.7L29.5 2.02309H8.93814C8.82236 2.02309 8.71069 1.97791 8.6278 1.89678Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6173 1.90749L8.6278 1.89678L8.61731 1.9075C8.70303 1.99139 8.81847 2.03809 8.93814 2.03809H29.4924L29.985 2.70494V13.5184L29.4054 14.098H0.526721L0.015 13.5243V0.015H6.68532L8.6173 1.90749Z",
    stroke: "url(#paint0_linear_356_7)",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6173 1.90749L8.6278 1.89678L8.61731 1.9075C8.70303 1.99139 8.81847 2.03809 8.93814 2.03809H29.4924L29.985 2.70494V13.5184L29.4054 14.098H0.526721L0.015 13.5243V0.015H6.68532L8.6173 1.90749Z",
    stroke: "url(#paint1_linear_356_7)",
    strokeWidth: 0.03
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_356_7",
    x: -23,
    y: -23,
    width: 76,
    height: 60.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_356_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_356_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_356_7",
    x1: -0.632321,
    y1: -1.69112,
    x2: 13.5163,
    y2: 11.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_356_7",
    x1: 32.2219,
    y1: 17.3296,
    x2: 23.9711,
    y2: 11.6236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDesktop);
export default __webpack_public_path__ + "static/media/home_desktop.630d77fbfd6664ed092a815f422dd61d.svg";
export { ForwardRef as ReactComponent };